import * as React from "react";

const UsersGroupSVG = ({ className }: { className?: string }) => (
  <svg
    className={`svg ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="User / Users_Group">
      <path
        id="Vector"
        d="M14.1667 16.6666C14.1667 15.2859 12.3012 14.1666 10 14.1666C7.69881 14.1666 5.83333 15.2859 5.83333 16.6666M17.5 14.1669C17.5 13.1418 16.4716 12.2607 15 11.875M2.5 14.1669C2.5 13.1418 3.52841 12.2607 5 11.875M15 8.53005C15.5115 8.07228 15.8333 7.40704 15.8333 6.66663C15.8333 5.28591 14.714 4.16663 13.3333 4.16663C12.693 4.16663 12.109 4.40734 11.6667 4.8032M5 8.53005C4.48854 8.07228 4.16667 7.40704 4.16667 6.66663C4.16667 5.28591 5.28595 4.16663 6.66667 4.16663C7.30696 4.16663 7.89104 4.40734 8.33333 4.8032M10 11.6666C8.61929 11.6666 7.5 10.5473 7.5 9.16663C7.5 7.78591 8.61929 6.66663 10 6.66663C11.3807 6.66663 12.5 7.78591 12.5 9.16663C12.5 10.5473 11.3807 11.6666 10 11.6666Z"
        stroke="#F8F8F8"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default UsersGroupSVG;
